import {
    UNIT_TYPE_EVENTS_SHOW,
    UNIT_TYPE_EVENTS_SHOW_RESULT,
    UNIT_TYPE_EVENTS_SHOW_HIDE
} from 'Redux/actionTypes';

export const showUnitTypeEventsOpenModal = (unitType) => ({
    type: UNIT_TYPE_EVENTS_SHOW,
    payload: unitType 
});

export const showUnitTypeEventsGetDataResult = (data) => ({
    type: UNIT_TYPE_EVENTS_SHOW_RESULT,
    payload: data
});

export const showUnitTypeEventsHide = () => ({
    type: UNIT_TYPE_EVENTS_SHOW_HIDE,
    //payload: users
  });